<template>
    <div>
        <div class="text-slate-700 text-base font-bold">Company Name</div>
        <div class="text-sm leading-tight mb-4 text-slate-500">
            Your company's name. Used by the AI to introduce itself when responding to customers.
        </div>

        <vx-input
            counter
            :maxlength="120"
            placeholder="Acme Inc."
            size="lg"
            :disabled="props.disabled"
            :error="props.error"
            :modelValue="props.modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
        >
        </vx-input>
    </div>
</template>

<script setup>
import { VxInput } from '@voxie/frontend-components';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: undefined,
    },
});

const emit = defineEmits(['update:modelValue']);
</script>
